/**
 * @generated SignedSource<<76d4d0bfc92ee252ffe60432dbdeb4a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AddSourceTagInput = {
  clientMutationId?: string | null;
  pageId: string;
  sourceId: string;
  key?: string | null;
  value?: string | null;
};
export type SourceTagReferenceModal_AddMutation$variables = {
  input: AddSourceTagInput;
};
export type SourceTagReferenceModal_AddMutationVariables = SourceTagReferenceModal_AddMutation$variables;
export type SourceTagReferenceModal_AddMutation$data = {
  readonly addSourceTag: {
    readonly sourceTag: {
      readonly id: string;
      readonly key: string | null;
      readonly value: string | null;
      readonly source: {
        readonly id: string;
        readonly name: string;
      };
      readonly pageUrl: string;
    };
  } | null;
};
export type SourceTagReferenceModal_AddMutationResponse = SourceTagReferenceModal_AddMutation$data;
export type SourceTagReferenceModal_AddMutation = {
  variables: SourceTagReferenceModal_AddMutationVariables;
  response: SourceTagReferenceModal_AddMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddSourceTagPayload",
    "kind": "LinkedField",
    "name": "addSourceTag",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SourceTag",
        "kind": "LinkedField",
        "name": "sourceTag",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "key",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Source",
            "kind": "LinkedField",
            "name": "source",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pageUrl",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SourceTagReferenceModal_AddMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SourceTagReferenceModal_AddMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "4be1dc67bc02d194b8daf9ba71dc3be0",
    "id": null,
    "metadata": {},
    "name": "SourceTagReferenceModal_AddMutation",
    "operationKind": "mutation",
    "text": "mutation SourceTagReferenceModal_AddMutation(\n  $input: AddSourceTagInput!\n) {\n  addSourceTag(input: $input) {\n    sourceTag {\n      id\n      key\n      value\n      source {\n        id\n        name\n      }\n      pageUrl\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2447bf0376d2bcbad1d218f986b27752";

export default node;
